(function () {
  'use strict';

  function handleUpsellAdd(button) {
    if (button.disabled) return;
    var variantId = button.dataset.variantId;
    if (!variantId) return;

    var originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';
    button.style.opacity = '0.7';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw new Error(data.description || 'Add failed');
          });
        }
        return response.json();
      })
      .then(function () {
        return fetch('/?sections=cart-drawer,cart-icon-bubble');
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (sections) {
        var parser = new DOMParser();

        // Update the cart drawer
        if (sections['cart-drawer']) {
          var drawerDoc = parser.parseFromString(sections['cart-drawer'], 'text/html');
          var newDrawerInner = drawerDoc.querySelector('.drawer__inner');
          var liveDrawerInner = document.querySelector('cart-drawer .drawer__inner');
          if (liveDrawerInner && newDrawerInner) {
            liveDrawerInner.innerHTML = newDrawerInner.innerHTML;
            liveDrawerInner.classList.remove('is-empty');
          }
        }

        // Update the cart icon bubble (count in header)
        if (sections['cart-icon-bubble']) {
          var bubbleDoc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
          var newBubbleSection = bubbleDoc.querySelector('.shopify-section');
          var liveBubble = document.getElementById('cart-icon-bubble');
          if (liveBubble && newBubbleSection) {
            liveBubble.innerHTML = newBubbleSection.innerHTML;
          }
        }

        // Make sure the drawer stays open
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
      })
      .catch(function (err) {
        console.error('Cart upsell add failed:', err);
        button.disabled = false;
        button.textContent = originalText;
        button.style.opacity = '1';
      });
  }

  // Global event delegation — works for buttons inserted at any time
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-upsell-add]');
    if (btn) {
      e.preventDefault();
      handleUpsellAdd(btn);
    }
  });
})();
